import { Container, Row, Col } from "react-bootstrap";
import aboutImage from "../../Assets/sanjeet.png";
import Particle from "../Particle";
import MiddleSection from "./MiddleSection";
import Type from "./Type";

function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hello World{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>

              <h1 className="heading-name">
                I'M
                <strong className="main-name"> SANJEET PATHAK</strong>
              </h1>

              <div style={{ padding: 50, textAlign: "left" }}>
                <Type />
              </div>
            </Col>

            <Col md={5} style={{ paddingBottom: 20 }} className="blob-container">
              <div className="blob">
                <img
                  src={aboutImage}
                  alt="about pic"
                  className="img-fluid"
                  style={{ maxHeight: "450px", width: "100%", height: "100%", objectFit: "contain" }}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
      <MiddleSection />
    </section>
  );
}

export default Home;
